var styles = [".modal-content[_ngcontent-%COMP%]{display:flex;justify-content:space-between}"];
export { styles as styles };
